import { render, staticRenderFns } from "./DeleteCampaign.vue?vue&type=template&id=c3b0e8bc&scoped=true"
import script from "./DeleteCampaign.vue?vue&type=script&lang=js"
export * from "./DeleteCampaign.vue?vue&type=script&lang=js"
import style0 from "./DeleteCampaign.vue?vue&type=style&index=0&id=c3b0e8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b0e8bc",
  null
  
)

export default component.exports